<template>
  <div class="listMenu-card">
    <div class="card-header">
      <h3 class="card-title">Help Center</h3>
    </div>
    <div class="listMenu">
      <nuxt-link v-for="(item, index) in list" :key="item.id" class="item" :class="{ active: item.id == current }" :to="{ name: 'index-faq-articles', params: { articles: item.id } }">
        <span class="item-index">{{ String(index + 1).padStart(2, '0') }}</span>
        <span class="item-text">{{ item.title }}</span>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'listMenu',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: 0
    }
  },
  computed: {},
  watch: {
    '$route.params.articles': {
      handler(val) {
        this.setActive(val)
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    setActive(val) {
      const list = this.list
      const index = list.findIndex(item => {
        return item.id === val
      })
      if (index > -1) {
        this.current = list[index].id
      } else {
        this.current = list[0].id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.listMenu-card {
  margin-right: 30px;
  flex-shrink: 0;
  width: 300px;
  height: min-content;
  position: sticky;
  top: 100px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.card-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f0f2f5;
}
.card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: -0.3px;
}
.listMenu {
  padding: 8px 0;
}
.item {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 24px;
  margin-bottom: 0;
  color: #525861;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 3px solid transparent;
  position: relative;
}
.item-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #f5f6f8;
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  margin-right: 14px;
  flex-shrink: 0;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.item-text {
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item:hover {
  background: #f8f9fc;
  color: #1a1a2e;
}
.item:hover .item-index {
  background: #e8edf8;
  color: #3067f2;
}
.item.active {
  background: linear-gradient(90deg, rgba(48, 103, 242, 0.06) 0%, rgba(48, 103, 242, 0.02) 100%);
  color: #1a1a2e;
  font-weight: 600;
  border-left-color: #3067f2;
}
.item.active .item-index {
  background: #3067f2;
  color: #fff;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .listMenu-card {
    width: 100%;
    margin-right: 0;
    position: relative;
    top: 0;
    height: auto;
    border-radius: 0;
    box-shadow: none;
    background: #fafbfc;
  }
  .card-header {
    padding: 16px 20px 12px;
  }
  .card-title {
    font-size: 16px;
  }
  .item {
    height: 48px;
    padding: 0 20px;
  }
  .item:hover {
    background: transparent;
  }
  .item.active {
    background: linear-gradient(90deg, rgba(48, 103, 242, 0.06) 0%, rgba(48, 103, 242, 0.02) 100%);
  }
  .item:hover .item-index {
    background: #f5f6f8;
    color: #9ca3af;
  }
  .item.active:hover .item-index {
    background: #3067f2;
    color: #fff;
  }
}
</style>
